let idCounter = -1;

function getUniqueId(prefix = '') {
  const id = ++idCounter;
  return prefix + id;
}

export default getUniqueId;
